export default __webpack_public_path__ + "static/p3-867933f01e6d2c7527e44ff57a5618ab.jpg";